// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.c-table__cell_created .c-table__cell-value {\n  white-space: nowrap;\n}\n\n", ""]);
// Exports
module.exports = exports;
